import { SurveyQuestionTypeEnum } from '@elearning-platform/api-types/enums';
import {
  SurveyPageInterface,
  SurveyQuestionInterface,
  SurveySectionInterface,
  UserSurveyOpenInterface,
} from '@elearning-platform/api-types/interfaces';

import { SurveyQuestionEntry } from '../../interfaces';

import { extractAnswerValue } from './extractAnswerValue.utils';
import { reversedFieldKeys } from './reversedFieldKeys.utils';

export const getFormInitialValues: (survey: UserSurveyOpenInterface) => Record<string, string | boolean>
= (survey: UserSurveyOpenInterface): Record<string, string | boolean> => {
  const allQuestions: SurveyQuestionEntry[] = survey.pages.flatMap((page: SurveyPageInterface): SurveyQuestionEntry[] =>
    page.sections.flatMap((section: SurveySectionInterface): SurveyQuestionEntry[] =>
      section.questions.map((question: SurveyQuestionInterface): SurveyQuestionEntry => ({
        key: `${section.type}|${question.question}`,
        answers: question.answers,
        type: question.type,
      }))
    )
  );

  return Object.fromEntries(
    allQuestions.flatMap(({ key, answers, type }: SurveyQuestionEntry): [string, string | boolean][] => {
      const rawValue: string | undefined = reversedFieldKeys[key] ? extractAnswerValue(answers) : undefined;
      if (rawValue === undefined || !reversedFieldKeys[key]) {
        return [];
      }
      const value: string | boolean = type === SurveyQuestionTypeEnum.SingleChoice
        ? rawValue === 'Tak'
        : rawValue;

      return [[reversedFieldKeys[key], value]];
    })
  );
};
